module.exports = vue3_library_v5;